
import SocialMedia from './SocialMedia';
const ContactUs = () => {
  return (
    <section className="ftco-section ftco-no-pb">
<div className="container">
<div className="row justify-content-center pb-4">
    <div className="col-md-12  heading-section ftco-animate text px-4">
      <h2 className="mb-4 text-success text-center">
      Contact Us 
      </h2>   
    </div>
  </div>
    
  <div className="row mt-3">
    <div className=" col-md-12 order-md-first">
      <div className="text px-4">
    
              <p> 
              We would love to hear from you! For any inquiries regarding admissions, events, or general information, feel free to reach out to us.

  </p>
              <p>
              <strong>📍 School Address:</strong><br/>
              SRN Matriculation School<br/>
SRN Line Thottam, Rangasamudram, Sathyamangalam, India 638402 Tamil Nadu<br/>
              </p>
              <p>
<strong>📞 Phone:</strong><br/>
+91 98949 93212<br/>
+91 98949 93212<br />
                </p>
<p>
<strong>📧 Email:</strong><br/>
srnschool2015@gmail.com<br/>
</p><p>
<strong>🕒 Office Hours:</strong><br/>
Monday – Friday: 8.00 A.M to 6 P.M<br/>
Saturday: 8.00 A.M to 5 P.M<br/>
Sunday: Closed<br/>
              </p>
              <p>
📲 Follow Us on Social Media:<br/>

<p className="d-flex justify-content-between secondary">
   
        <SocialMedia />
      </p>
We are here to assist you! Feel free to visit or contact us for any information.<br/>

Best Regards,<br/>
<strong>SRN Matriculation School</strong>
              </p>  
                           
        </div>
    </div>

  
  </div>  
  </div>
  {/* <hr className="custom-hr"/> */}
    </section>
  );
};

export default ContactUs;
